import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    cities: null,
});

class Store extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_CITIES_FINISH:
                return state.set('cities', action.cities);

            default:
                return state;
        }
    }
}

export default new Store();




// WEBPACK FOOTER //
// src/stores/NucleoStore.js